import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ConfigProvider, App as AntdApp } from 'antd';
import vi_VN from 'antd/lib/locale/vi_VN';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/vi';
import { setNotificationInstance } from './utils/alert';

import { createRoot } from 'react-dom/client';

dayjs.extend(updateLocale);
dayjs.updateLocale('vi', {
    weekStart: 1,
});
dayjs.locale('vi');

/** Bridge component that extracts antd's context-aware notification API
 *  and exposes it to the non-React utility module (alert.js). */
const AntdStaticBridge = ({ children }) => {
    const { notification } = AntdApp.useApp();
    React.useEffect(() => {
        setNotificationInstance(notification);
    }, [notification]);
    return children;
};

const container = document.getElementById('root');

const root = createRoot(container);
const antdTheme = {
    token: { fontFamily: 'Tahoma', fontSize: 13, borderRadius: 2 },
};
root.render(
    <ConfigProvider locale={vi_VN} theme={antdTheme}>
        <AntdApp>
            <AntdStaticBridge>
                <App />
            </AntdStaticBridge>
        </AntdApp>
    </ConfigProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
